module.exports = __webpack_public_path__ + "static/img/logo51.79f4af3.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo51.png
// module id = rRxQ
// module chunks = 1